import { useMemo } from "react";
import { useParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";

import Typography from "core/components/Typography";
import { useMembershipListQuery, useOrganizationByIdQuery } from "core/queries";
import { CredentialNavSection } from "modules/admin/CredentialNavSection";

const OrganizationCredentialsPage = () => {
  const { orgId: organizationId } = useParams();
  const queryClient = useQueryClient();

  const { data: organization, isLoading: isOrgLoading } =
    useOrganizationByIdQuery({ organizationId });

  const { isLoading: isMembersLoading, data: members } = useMembershipListQuery(
    {
      orgId: organizationId,
      select: (data) => {
        return data.rows.map((member) => {
          member.userId = member.user_id;
          return member;
        });
      },
    }
  );

  const enrichedOrg = useMemo(
    () => ({ ...organization, members: members || [] }),
    [organization, members]
  );

  const handleMutationSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: ["organizations", { organizationId }],
    });
  };

  return (
    <div style={{ maxWidth: "700px" }}>
      <Typography variant="h2">Data Credentials</Typography>

      <CredentialNavSection
        type="org"
        entity={enrichedOrg}
        isLoading={isOrgLoading || isMembersLoading}
        onMutationSuccess={handleMutationSuccess}
      />
    </div>
  );
};

export default OrganizationCredentialsPage;
